<template>
	<div v-if="name" class="read-more-box" @click="$router.push({ name })">
		<span class="read-more-text" :class="is_phone ? 'fs-12':'fs-14'" v-if="text">{{$store.state.language == 'EN' ? 'Read more':'阅读更多'}}</span>
		<div class="out-box"><div class="in-box">></div></div>
	</div>
	<a v-else class="read-more-box" :href="url" target="_blank">
		<span class="read-more-text" :class="is_phone ? 'fs-12':'fs-14'" v-if="text">{{$store.state.language == 'EN' ? 'Read more':'阅读更多'}}</span>
		<div class="out-box"><div class="in-box">></div></div>
	</a>
</template>

<script>
export default {
	name: '',
	props: {
		text: { default: '阅读更多' },
		url: {},
		name: {}
	},
	data() {
		return {};
	},
	created() {},
	methods: {}
};
</script>

<style scoped="scoped">
.read-more-box {
	position: relative;
	display: flex;
	align-items: center;
	height: 0.6rem;
	transition: all 0.4s;
}
.read-more-box:hover {
	color: #d81216;
}

.read-more-text {
	font-size: 0.14rem;
	line-height: 24px;
}
.out-box {
	border: 1px solid rgba(223, 223, 223, 1);
	border-radius: 50%;
	transition: all 0.3s;
	padding: 0.05rem;
	margin-left: 0.2rem;
}
.read-more-box:hover .out-box {
	animation: big 0.6s;
	animation-delay: 0.2s;
	animation-fill-mode: forwards;
}
@keyframes big {
	70% {
		border: 1px solid rgba(223, 223, 223, 0);
	}
	100% {
		border: 1px solid rgba(223, 223, 223, 0);
		/* transform: translateX(.1rem); */
	}
}
.in-box {
	width: 0.25rem;
	height: 0.25rem;
	line-height: 0.25rem;
	text-align: center;
	font-size: 12px;
	border-radius: 50%;
	transition: all 0.3s;
}
.read-more-box:hover .in-box {
	background-color: #d81216;
	color: #ffffff;
	width: 0.35rem;
	height: 0.35rem;
	line-height: 0.35rem;
}

.read-more-img {
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	cursor: pointer;
	width: 0.4rem;
	height: 0.4rem;
	display: inline-block;
	margin-left: 0.2rem;
	background-image: url(https://imgtest.togy.com.cn/oyjj/langGuo/icon/next_one.png);
}
.read-more-box:hover .read-more-img {
	background-image: url(https://imgtest.togy.com.cn/oyjj/langGuo/icon/next_one2.png);
}
</style>



// WEBPACK FOOTER //
// src/components/readMore.vue